import React, { createContext, useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withPrefix } from "gatsby";
import InfoModal from "../components/info-modal";
import CrosslineCompareModal from "../components/crossline-compare-modal";

const CompareContext = createContext({
  productIds: [],
  toggleProduct: () => undefined,
  removeProduct: () => undefined,
  clearProducts: () => undefined,
});

export const CompareProvider = ({ category, products, children }) => {
  const [productIds, setProductIds] = useState([]);
  const [pageSlug, setPageSlug] = useState();
  const [loaded, setLoaded] = useState(false);
  const [productId, setProductId] = useState();
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const closeWarningModal = useCallback(() => setWarningModalVisible(false), []);
  const [infoModalVisible, setInfoModalVisible] = useState(false);
  const closeInfoModal = useCallback(() => setInfoModalVisible(false), []);

  useEffect(() => {
    if (productIds.length && products) {
      const product = products?.find((prod) => prod.key_prod === productIds[0]);
      setPageSlug(product.pageLine.slug);
    } else {
      setPageSlug();
    }
  }, [productIds, products]);

  const toggleProduct = useCallback(
    (id) =>
      setProductIds((list) => {
        if (list.includes(id)) {
          return list.filter((item) => item !== id);
        } else {
          const product = products?.find((prod) => prod.key_prod === id);
          if (product?.pageLine?.slug === pageSlug || !pageSlug) {
            if (list.length < 3) {
              return list.concat(id);
            } else {
              setWarningModalVisible(true);
              return list;
            }
          } else {
            setProductId(id);
            setInfoModalVisible(true);
            return list;
          }
        }
      }),
    [pageSlug, products]
  );

  useEffect(() => {
    const storageData = localStorage.getItem(withPrefix(`_comp-${category}`).substring(1));
    if (storageData) {
      const { productIds = [] } = JSON.parse(storageData);
      setProductIds(productIds);
    }
    setLoaded(true);
  }, [category]);
  const removeProduct = useCallback(
    (id) => setProductIds((list) => list.filter((item) => item !== id)),
    []
  );
  const clearProducts = useCallback(() => setProductIds([]), []);

  const updateCompare = useCallback(() => setProductIds([productId]), [productId]);

  useEffect(() => {
    const storageKey = withPrefix(`_comp-${category}`).substring(1);
    if (productIds.length) {
      localStorage.setItem(storageKey, JSON.stringify({ productIds }));
    } else {
      localStorage.removeItem(storageKey);
    }
  }, [productIds, category]);

  return (
    <CompareContext.Provider
      value={{ productIds, toggleProduct, removeProduct, clearProducts, loaded }}
    >
      {children}
      <InfoModal
        show={warningModalVisible}
        msgKey="max3Productscompare"
        onHide={closeWarningModal}
      />
      <CrosslineCompareModal
        show={infoModalVisible}
        onHide={closeInfoModal}
        updateCompare={updateCompare}
      />
    </CompareContext.Provider>
  );
};

CompareProvider.propTypes = {
  category: PropTypes.string.isRequired,
};

export default CompareContext;
